var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-box" }, [
    _c("header", { staticClass: "container" }, [
      _c("div", { staticClass: "header flex-space-between" }, [
        _c("div", { staticClass: "header-logo flex-align-center" }, [
          _vm._m(0),
          _vm.isEnv
            ? _c("div", { staticClass: "header-v" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("layout.header.testnet")))]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "header-nav flex-align-center" }, [
            _c("ul", { staticClass: "flex-align-center header-nav-ul" }, [
              _c(
                "li",
                { class: { active: _vm.$route.meta.name === "Home" } },
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("layout.header.nav.markets"))),
                    ]),
                  ]),
                ],
                1
              ),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.liquidityPoolUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("i", { staticClass: "icon icon-nav_arrow" }),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("layout.header.nav.liquidityPool"))),
                    ]),
                  ]
                ),
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.fxbridgeUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("i", { staticClass: "icon icon-nav_arrow" }),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("layout.header.nav.bridge"))),
                    ]),
                  ]
                ),
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.starScanUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("i", { staticClass: "icon icon-nav_arrow" }),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("layout.header.nav.starScan"))),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "header-nav flex-align-center" }, [
          _c(
            "div",
            { staticClass: "header-connect-wallet" },
            [_c("ConnectWallet", { staticClass: "connect-wallet-but" })],
            1
          ),
          _c(
            "div",
            { staticClass: "flex-align-center header-more-information" },
            [
              _c("div", { staticClass: "nav-menu-normal" }, [
                _vm._m(1),
                _c(
                  "ul",
                  [
                    _vm._l(_vm.moreInformationEnvListComputed, function (m) {
                      return _c(
                        "a",
                        {
                          key: m.value,
                          attrs: {
                            href: m.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c("li", { staticClass: "more-information-li" }, [
                            _c("i", { class: ["icon", m.iconName] }),
                            _c("strong", [_vm._v(_vm._s(m.text))]),
                          ]),
                        ]
                      )
                    }),
                    _vm._l(_vm.moreInformationListComputed, function (m) {
                      return _c(
                        "a",
                        {
                          key: m.value,
                          attrs: {
                            href: m.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c("li", { staticClass: "more-information-li" }, [
                            _c("i", { class: ["icon", m.iconName] }),
                            _c("strong", [_vm._v(_vm._s(m.text))]),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "nav-menu-down-h-3x" }, [
                _c("i", { staticClass: "icon icon-down-nav" }),
                _c("div", { staticClass: "down-box flex-align-center" }, [
                  _c("div", { staticClass: "qr-img" }, [
                    _c("img", {
                      staticClass: "qrimg",
                      attrs: { src: _vm.qrImg, alt: "" },
                    }),
                  ]),
                  _c("div", { staticClass: "down-text" }, [
                    _c("h6", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("layout.header.download.downloadfxWallet")
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "layout.header.download.downloadfxWalletPlease"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "nav-menu-qkyy" }, [
                _c("i", { staticClass: "icon icon-qkyy" }),
                _c(
                  "ul",
                  _vm._l(_vm.languageList, function (l, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        class: [
                          "more-information-li",
                          { active: l.value === _vm.$i18n.locale },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.switchLang(l.value)
                          },
                        },
                      },
                      [_c("strong", [_vm._v(_vm._s(l.text))])]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "a-link flex-align-center",
        attrs: {
          href: "https://marginx.io",
          target: "_blank",
          rel: "noopener noreferrer",
        },
      },
      [
        _c("i", { staticClass: "icon icon-logo" }),
        _c("i", { staticClass: "icon icon-logo-font" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-normal" }, [
      _c("div", { staticClass: "menu-normal-1" }),
      _c("div", { staticClass: "menu-normal-2" }),
      _c("div", { staticClass: "menu-normal-3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }